import { render } from "./CreateFirstPassword.vue?vue&type=template&id=4e6220e5&scoped=true"
import script from "./CreateFirstPassword.vue?vue&type=script&lang=js"
export * from "./CreateFirstPassword.vue?vue&type=script&lang=js"

import "./CreateFirstPassword.vue?vue&type=style&index=0&id=4e6220e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6220e5"]])

export default __exports__